<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="justify-center">{{
          $t("common.invoice")
        }}</v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-center">
          <v-spacer></v-spacer>

          <span>
            {{ $t("modal.doYouWantToReceiveYourTicketInvoiceInYour") }}
            <strong style="text-transform: uppercase; font-size: large"
              >E-MAIL</strong
            >?
          </span>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="email"
            :loading="loading"
            :disabled="loading"
          ></v-text-field>
          <v-spacer></v-spacer>

          <Factura ref="facturaRef" />

          <v-btn
            v-if="!loading"
            @click="closeDialog"
            color="light"
            text
            style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
          >
            <font-awesome-icon
              icon="times-circle"
              :style="{ color: '#ea2222', fontSize: 50 }"
            />
          </v-btn>

          <v-btn
            v-if="!loading"
            @click="handleSendEmail"
            color="light"
            text
            style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
          >
            <font-awesome-icon
              icon="check-circle"
              :style="{ color: '#11bd11', fontSize: 50 }"
            />
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import { updatePayment } from "@/collections/payments";
import Factura from "@/components/public/common/Factura";
import moment from "moment";
import { updateSetting } from "@/collections/settings";
import { ordersCollection } from "@/collections/orders";
export default {
  name: "send-email-modal",
  props: [
    "tableQR",
    "paymentType",
    "isPaid",
    "paymentMethod",
    "externalPaymentId"
  ],
  components: {
    Factura
  },
  mixins: [firebaseMixin],
  data() {
    return {
      canBeDirectPayment: false,
      dialog: false,
      amountPaid: 0,
      total: 0,
      orders: [],
      loading: false,
      invitationTotal: 0,
      nextNumber: 0,
      paymentOn: null
    };
  },
  computed: {
    email() {
      return this.$store.getters.getEmail(false);
    },
    paymentId() {
      return this.$router.currentRoute.query.p_id;
    }
  },
  mounted() {
    this.paymentOn = moment().toDate();
    setTimeout(async () => {
      this.nextNumber = await this.getNextNumber();
    }, 1000);
  },
  methods: {
    getInvitationTotalPrice(orders) {
      let total = 0;
      orders.forEach(item => {
        if (item.selectOption === "invitation") {
          total += 1 * item.price + this.totalWithAdditionalCharge(item);
        }
      });
      return total;
    },
    async getOpenOrders() {
      try {
        let self = this;
        // payment is not direct and coming from receipt view, then get all the open orders to send in email
        if (!this.canBeDirectPayment && this.isPaid) {
          this.loading = true;
          await ordersCollection
            .where("isOpen", "==", true)
            .where("tableQR", "==", self.tableQR)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                self.orders.push(doc.data());
              });

              self.orders.forEach(x => {
                if (x.isMenuGroupProduct) {
                  x.starters.forEach(starter => {
                    self.total +=
                      parseFloat(starter.additional_charge) * x.quantity;
                  });
                  x.maincourse.forEach(main => {
                    self.total +=
                      parseFloat(main.additional_charge) * x.quantity;
                  });
                  x.desserts.forEach(dessert => {
                    self.total +=
                      parseFloat(dessert.additional_charge) * x.quantity;
                  });
                  x.drinks.forEach(drink => {
                    self.total +=
                      parseFloat(drink.additional_charge) * x.quantity;
                  });
                }
                self.total += x.price * x.quantity;
              });

              self.loading = false;
            });
        }
      } catch (error) {
        this.setlogError(
          "orders_collection",
          "Obtained error message in getOpenOrders()",
          error.stack,
          this.$options.name
        );
        this.loading = false;
      }
    },
    async openDialog(orders = [], amountPaid = 0, canBeDirectPayment = false) {
      this.canBeDirectPayment = canBeDirectPayment;
      this.dialog = true;
      if (this.canBeDirectPayment) {
        this.orders = orders;
      } else {
        this.getOpenOrders();
      }
      this.amountPaid = amountPaid;
    },
    async handleSendEmail() {
      let baseUrl = this.projectUrl;
      let color = this.colorsGeneralPrimary;
      this.loading = true;
      try {
        // eslint-disable-next-line no-unused-vars
        let missingAmountToPay =
          localStorage.getItem("missingAmountToPay") || 0;
        if (this.canBeDirectPayment) {
          this.total = this.getTotalPrice(this.orders);
          this.invitationTotal = this.getInvitationTotalPrice(this.orders);
        }
        let nextInvoiceNumber =
          this.$refs.facturaRef.invoiceRequest === true
            ? await this.getNextInvoiceNumber()
            : "";

        this.$api.admin.sendEmail({
          color: color,
          logo:
            this.settings && this.settings.icons
              ? this.settings.icons.logo
              : "",
          orders: JSON.stringify(this.orders),
          total: this.total - this.invitationTotal,
          amountPaid: parseFloat(this.amountPaid).toFixed(2),
          to: this.email,
          from: process.env.VUE_APP_PROJECT_NAME,
          config_smtp:
            this.settings && this.settings.config_smtp
              ? this.settings.config_smtp
              : null,
          date: this.dayFormat2(this.paymentOn),
          time: this.formatTime2(this.paymentOn),
          subject:
            this.$t("payment.receiptOfYourPaymentTo") + ` ${this.projectName}`,
          footerUrls: [
            {
              text: this.$t("common.cookies"),
              url: `${baseUrl}/cookies`
            },
            {
              text: this.$t("common.privacy"),
              url: `${baseUrl}/privacy`
            },
            {
              text: this.$t("common.termsAndConditions"),
              url: `${baseUrl}/terms`
            },
            {
              text: "by aiwanna pay",
              url: `https://www.aiwannapay.com/`
            }
          ],
          legal_number:
            this.$refs.facturaRef.invoiceRequest === true
              ? nextInvoiceNumber
              : this.nextNumber,
          invoiceRequest: this.$refs.facturaRef.invoiceRequest,
          company: {
            name: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.name
              : "",
            address: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.address
              : "",
            nif: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.nif
              : "",
            postal_code: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.postal_code
              : "",
            city: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.city
              : ""
          },
          settings: this.settings,
          tableQR: this.tableQR,
          number: this.nextNumber,
          paymentMethod: this.paymentMethod,
          curr_language: this.$i18n.locale,
          email_trans: {
            mesa: this.$t("email.mesa") || "Mesa",
            product: this.$t("email.product") || "Producto",
            quantity: this.$t("email.quantity") || "Cantidad",
            price: this.$t("email.price") || "Precio",
            total: this.$t("email.total") || "Total de la cuenta",
            totalPaid: this.$t("email.totalPaid") || "Total Pagado",
            baseTax: this.$t("email.baseTax") || "Base imponible",
            VAT: this.$t("email.VAT") || "IVA",
            paymentMethod: this.$t("email.paymentMethod") || "Forma de pago",
            pagado: this.$t("email.pagado") || "Pagado"
          }
        });

        this.$store.commit("setCustomerEmail", this.email);
        await this.storePayment(true, this.nextNumber, nextInvoiceNumber);
        this.redirect();
        this.dialog = false;
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async closeDialog() {
      this.loading = true;

      await this.storePayment(false, this.nextNumber);
      this.redirect();
      this.loading = false;
      this.dialog = false;
    },
    async storePayment(
      receiptIsSent,
      nextNumber,
      nextInvoiceNumber = nextNumber
    ) {
      try {
        let paymentType = "";
        if (!this.canBeDirectPayment) {
          paymentType = this.paymentType;
        }

        let z_closure_id = await this.getzClosureIdAndUpdateWithPaymentMethodGiven(
          this.paymentMethod
        );
        let now = moment().toDate();
        let payment = {
          tableQR: this.tableQR,
          email: this.email,
          orders: this.orders,
          receipt_is_sent: receiptIsSent,
          payment_method: this.paymentMethod,
          amount_paid_by_user: this.amountPaid,
          total_amount_order: this.getTotalPrice(this.orders),
          payment_type: paymentType,
          cash_payment: null,
          number: nextNumber,
          legal_number: this.$refs.facturaRef.invoiceRequest
            ? nextInvoiceNumber
            : nextNumber,
          z_closure_id: z_closure_id,
          invoiceRequest: this.$refs.facturaRef.invoiceRequest,
          company: {
            name: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.name
              : "",
            address: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.address
              : "",
            nif: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.nif
              : "",
            postal_code: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.postal_code
              : "",
            city: this.$refs.facturaRef.invoiceRequest
              ? this.$refs.facturaRef.company.city
              : ""
          },
          isAddedToSummary: false,
          updated_on: now
        };

        if (this.externalPaymentId) {
          payment.externalPaymentId = this.externalPaymentId;
        }

        // actual payment done
        await updatePayment(this.paymentId, payment);

        this.setlogError(
          "send-email-modal",
          "Payment updated successfully",
          payment,
          this.$options.name
        );

        if (this.$refs.facturaRef.invoiceRequest) {
          let data = this.settings;
          data.company.prev_inv_number = nextInvoiceNumber;
          await updateSetting("settings", data);
        }
      } catch (error) {
        this.setlogError(
          "send-email-modal",
          "Obtained error message",
          error.stack,
          this.$options.name
        );
      }
    },
    redirect() {
      if (this.canBeDirectPayment) {
        this.$router.replace("/recent");
      } else {
        this.$router.replace("/receipt");
      }
    }
  }
};
</script>

<style></style>
